
export const InputCharCount = ({value="", maxLength, onErrorMessage}) => {
    return <div className="InputCharCount">
        <div className={`inputCharCount ${value.length > maxLength ? 'error' : ''}`}>
            {value.length} / {maxLength}
        </div>
        {value.length > maxLength && onErrorMessage && <div className="errorMessage">
            {onErrorMessage}
        </div>}
    </div>
}